module.exports = __webpack_public_path__ + "img/1537248697.9d0e0837.jpg";